import { useUpsertAssessmentFeedbackMutation } from '@gql/gql-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';

interface TroubleshootingProps {
  assessmentId: string;
  onUserEndedInterview: () => void;
}

export const Troubleshooting = ({
  assessmentId,
  onUserEndedInterview,
}: TroubleshootingProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comment, setComment] = useState('');
  const [upsertFeedback] = useUpsertAssessmentFeedbackMutation();

  const handleSubmit = async () => {
    try {
      await upsertFeedback({
        variables: {
          input: {
            assessmentId,
            comment,
            isTechnicalDifficulty: true,
          },
        },
      });
      onUserEndedInterview();
    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
  };

  return (
    <>
      <Button
        variant='text'
        color='primary'
        sx={{
          ml: -1,
        }}
        onClick={() => setIsModalOpen(true)}
      >
        Having issues?
      </Button>

      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>Having issues with the interview?</DialogTitle>

        <DialogContent
          sx={{
            border: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography sx={{ my: 3 }}>
            Please describe your issue. Our Alignerr Operations team will look
            into it and help you retake the interview, if necessary.
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder='Enter your issues here'
            variant='outlined'
          />
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2,
            justifyContent: 'flex-start',
          }}
        >
          <Button
            variant='contained'
            color='primary'
            onClick={handleSubmit}
            disabled={!comment}
          >
            Submit & end interview
          </Button>
          <Button variant='outlined' onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
